import BaseModel from '@/store/models/BaseModel';

export default class Location extends BaseModel {}
